/**
 * @file index.tsx
 *
 * @fileoverview Shows a link to a phone number.
 */

export interface LinkPhoneProps {
  /**
   * The phone number.
   */
  phone: string;
}

export function LinkPhone({ phone }: LinkPhoneProps) {
  return <a href={`tel:${phone}`}>{phone}</a>;
}
